import { render } from "./ShadowBox.vue?vue&type=template&id=b46ea8ba"
import script from "./ShadowBox.vue?vue&type=script&lang=js"
export * from "./ShadowBox.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__